export default __webpack_public_path__ + "fed51269e045a3e4b6d2f1c0acc5ca28.ttf";